"use client";

import { AlertTriangle } from "lucide-react";

interface PropertyDisclaimerProps {
  className?: string;
  createdAt: string;
}

export function PropertyDisclaimer({
  className,
  createdAt,
}: PropertyDisclaimerProps) {
  return (
    <div className="px-4 py-3 md:container md:max-w-7xl md:mx-auto">
      <div className="flex items-center gap-2 text-gray-600">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <p className="text-xxs sm:text-sm">
          This analysis was generated on{" "}
          {new Date(createdAt).toLocaleDateString()}. It is for entertainment
          purposes only and should not be considered as real estate or
          investment advice.
        </p>
      </div>
    </div>
  );
}
